import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { Sidebar, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { RoadsideSidebar } from "../../containers/RoadsideSidebar"
import { useRoadsideStateContext } from "../../contexts/RoadsideContext"

export function RoadsideSidebarRouter() {
    const { ascendantCodes, descendantCodes } = useRoadsideStateContext()
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        { path: "/", element: <RoadsideSidebar /> },
        { path: "/:road/*", element: <RoadsideSidebar /> },
    ]), [])

    const sidebarCount = useMemo(() => {
        const hasAdditionalSidebar = ascendantCodes.length % 2 === 1 || descendantCodes.length > 1
        return Math.floor(ascendantCodes.length / 2) + (hasAdditionalSidebar ? 1 : 0)
    }, [ascendantCodes, descendantCodes])

    return <Sidebar shadowed={!isMobile && sidebarCount >= 2}>{useRoutes(sidebarRoutes)}</Sidebar>
}
